module.exports = __webpack_public_path__ + "img/ZJ5332.dae205dd.png";